import * as CryptoJS from "crypto-js";

export function isNullOrEmpty(text) {
  let isNullOrEmpty = false;

  if (text === "null" || text === "") {
    isNullOrEmpty = true;
  }

  if (typeof text !== "undefined" && text) {
    isNullOrEmpty = false;
  } else {
    isNullOrEmpty = true;
  }

  //Tento kod vrátí true, pokud je hodnota: null, undefined, "", 0, false nebo NaN nebo obsahuje "    " prazdne znaky.
  isNullOrEmpty = !text || text.trim().length === 0;

  return isNullOrEmpty;
}

export function isNullOrEmptyList(list, item) {
  let isEmpty = true;

  if (list) {
    list.forEach(function (arrayItem) {
      if (isEmpty) {
        if (!isNullOrEmpty(arrayItem[item])) {
          isEmpty = false;
        }
      }
    });
  }

  return isEmpty;
}

export function parseBool(str) {
  // console.log(typeof str);
  // strict: JSON.parse(str)

  if (str == null) return false;

  if (typeof str === "boolean") {
    if (str === true) return true;

    return false;
  }

  if (typeof str === "string") {
    if (str == "") return false;

    str = str.replace(/^\s+|\s+$/g, "");
    if (str.toLowerCase() == "true" || str.toLowerCase() == "yes") return true;

    str = str.replace(/,/g, ".");
    str = str.replace(/^\s*\-\s*/g, "-");
  }

  // var isNum = string.match(/^[0-9]+$/) != null;
  // var isNum = /^\d+$/.test(str);
  if (!isNaN(str)) return parseFloat(str) != 0;

  return false;
}

export function getPhoneLink(phone) {
  if (!phone) {
    return "";
  }

  return `tel:${phone.replace(/\s/g, "")}`;
}

export function getEmailLink(email) {
  if (!email) {
    return "";
  }

  return `mailto:${email.replace(/\s/g, "")}`;
}

export function stripHtml(html) {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

export function textShortener(text, len) {
  if (text && text.length > len) {
    text = text.substring(0, len) + "... (zkrácený text)";
  }
  return text;
}

export function needGoToDetail(text, len) {
  let needGoToDetail = false;
  if (text && text.length > len) {
    needGoToDetail = true;
  }
  return needGoToDetail;
}

export function encrypt(text) {
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const cipherText = CryptoJS.AES.encrypt(text, secretKey).toString();
  return cipherText;
}

export function decrypt(text) {
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const bytes = CryptoJS.AES.decrypt(text, secretKey);
  const plainText = bytes.toString(CryptoJS.enc.Utf8);
  return plainText;
}

export function getAuthConfig(uid) {
  //console.log(uid, process.env.REACT_APP_API_USERNAME, process.env.REACT_APP_API_PASSWORD);

  const base64 = "Basic " + btoa(uid + ":" + process.env.REACT_APP_API_USERNAME + ":" + process.env.REACT_APP_API_PASSWORD);
  //console.log(base64);

  return {
    headers: {
      Authorization: base64,
    },
  };
  //return { Authorization: "Basic " + btoa(uid + ":" + username + "" + pass) };
}

export function getRandomUID(len, numberOnly = false) {
  const chars = numberOnly ? "0123456789" : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let uid = "";
  for (let i = 0; i < len; i++) {
    uid += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return uid;
}

let lastGeneratedCardIDDay = null; // Uchovává poslední den, kdy byla kolekce resetována (Date object)
let todayUsedNonCardIdentificatorList = []; // Array použitých ID

/**
 * Pomocná metoda: Získá dnešní datum s časem nastaveným na 00:00:00.
 * Zajišťuje správné srovnání dnů bez vlivu času.
 * @returns {Date} Dnešní datum o půlnoci.
 */
function getTodayDateOnly() {
  const d = new Date();
  d.setHours(0, 0, 0, 0); // Nastavení času na půlnoc
  return d;
}

/**
 * Pomocná metoda: Porovnává, zda je Date1 (např. dnes) po Date2 (např. včera).
 */
function isDateAfter(date1, date2) {
  // Porovnává timestamp (milisekundy od epochy)
  return date1.getTime() > date2.getTime();
}

/**
 * Kontroluje, zda bylo ID pacienta dnes již použito.
 *
 * @param {string} id - Identifikátor pacienta (např. číslo karty).
 * @returns {boolean} true, pokud ID již existuje, false, pokud je nové.
 */
function checkPatientIdentificatorExistsToday(id) {
  let exists = true;

  // 1. Získání dnešního data o půlnoci (ekvivalent LocalDate)
  const today = getTodayDateOnly();

  // 2. Inicializace lastGeneratedCardIDDay při restartu
  if (lastGeneratedCardIDDay === null) {
    lastGeneratedCardIDDay = getTodayDateOnly();
  }

  // 3. Kontrola resetu kolekce (pokud je dnes NOVÝ den)
  if (isDateAfter(today, lastGeneratedCardIDDay)) {
    if (todayUsedNonCardIdentificatorList !== null) {
      console.log("helper", "getRandomIdentificator - checkPatientIdentificatorExistsToday mazu data pro novy den");

      // Smazání kolekce (nastavení na prázdné pole)
      todayUsedNonCardIdentificatorList = [];
      // Nastavení poslední dne na dnešek
      lastGeneratedCardIDDay = getTodayDateOnly();
    }
  }

  // 4. Kontrola existence ID a přidání nového
  if (todayUsedNonCardIdentificatorList !== null) {
    // JavaScript používá .indexOf() a porovnání s -1
    if (todayUsedNonCardIdentificatorList.indexOf(id) === -1) {
      exists = false;
      // Přidání ID do pole
      todayUsedNonCardIdentificatorList.push(id);
    }
  }

  console.log(lastGeneratedCardIDDay, todayUsedNonCardIdentificatorList);

  return exists;
}

function getRandomAlphabetChar() {
  // Generuje náhodný velký znak (A-Z)
  const alphabet = "ABCDEFHJKLMNPQVXZ"; //"ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const randomIndex = Math.floor(Math.random() * alphabet.length);
  return alphabet.charAt(randomIndex);
}

function getRandomInt(min, max) {
  // Generuje náhodné číslo v rozsahu [min, max] včetně (ekvivalent Java ThreadLocalRandom)
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function getRandomIdentificator() {
  let idetificator = null;
  const MAX_ATTEMPTS = 3;

  // Zkusit 3 pokusy na nalezení unikátního ID
  for (let i = 0; i < MAX_ATTEMPTS; i++) {
    // 1. Generování náhodného čísla 10-99 (rand.nextInt(99-10+1) + 10)
    const randomNumber = getRandomInt(10, 99);

    // 2. Sestavení ID (Znak + Číslo)
    // Přímá konkatenace v JS zajistí převod na řetězec
    idetificator = getRandomAlphabetChar() + String(randomNumber);

    // 3. Kontrola unikátnosti (předpokládá existenci checkPatientIdentificatorExistsToday)
    if (!checkPatientIdentificatorExistsToday(idetificator)) {
      console.log("helper", `getRandomIdentificator ${idetificator} not exists, attempt: ${i}`);
      break; // Nalezeno unikátní ID, ukončíme smyčku
    } else {
      console.log("helper", `getRandomIdentificator ${idetificator} already exists, attempt: ${i}`);
    }
  }

  return idetificator;
}
